<template>
  <multiselect
    :value="selectedCountry"
    :options="countries"
    :searchable="true"
    :show-labels="false"
    :allow-empty="false"
    :custom-label="compactLabel"
    :option-height="36"
    @input="onSelect"
    placeholder="+66"
    class="country-code-select"
    :internal-search="false"
    @search-change="onSearch"
  >
    <template slot="option" slot-scope="{ option }">
      <span class="country-option">
        {{ option.flag }} {{ option.nameEn }} ({{ option.nameTh }}) {{ option.dialCode }}
      </span>
    </template>
    <template slot="singleLabel" slot-scope="{ option }">
      <span class="country-selected">{{ option.flag }} {{ option.dialCode }}</span>
    </template>
  </multiselect>
</template>

<script>
import countryCodes from "@/data/countryCodes";

export default {
  name: "CountryCodeSelect",
  props: {
    value: {
      type: String,
      default: "TH",
    },
  },
  data() {
    return {
      countries: [...countryCodes],
      allCountries: countryCodes,
    };
  },
  computed: {
    selectedCountry() {
      return this.allCountries.find((c) => c.code === this.value) || this.allCountries[0];
    },
  },
  methods: {
    compactLabel(country) {
      return `${country.flag} ${country.dialCode}`;
    },
    onSelect(country) {
      if (country) {
        this.$emit("input", country.code);
        this.$emit("select", country);
      }
    },
    onSearch(query) {
      if (!query) {
        this.countries = [...this.allCountries];
        return;
      }
      const q = query.toLowerCase();
      this.countries = this.allCountries.filter(
        (c) =>
          c.nameEn.toLowerCase().includes(q) ||
          c.nameTh.includes(q) ||
          c.dialCode.includes(q) ||
          c.code.toLowerCase().includes(q)
      );
    },
  },
};
</script>

<style scoped>
.country-code-select {
  width: 85px;
  min-width: 85px;
  max-width: 85px;
  flex-shrink: 0;
}

.country-code-select >>> .multiselect__tags {
  min-height: 31px;
  max-height: 31px;
  padding: 4px 30px 0 8px;
  font-size: 0.875rem;
  border-radius: 0.2rem 0 0 0.2rem;
  border-right: none;
}

.country-code-select >>> .multiselect__single {
  font-size: 0.875rem;
  margin-bottom: 0;
  padding: 0;
  line-height: 1.4;
}

.country-code-select >>> .multiselect__select {
  height: 29px;
  padding: 2px 4px;
  width: 24px;
}

.country-code-select >>> .multiselect__input {
  font-size: 0.875rem;
  margin-bottom: 0;
  padding: 0;
}

.country-code-select >>> .multiselect__content-wrapper {
  width: 300px;
  min-width: 300px;
}

.country-option {
  font-size: 0.875rem;
  white-space: nowrap;
}

.country-selected {
  font-size: 0.875rem;
  white-space: nowrap;
}
</style>
